import { useEffect, useState } from 'react'
import API from 'api'
import { useDispatch } from 'react-redux'
import { setAdventureAvailability } from '../../../actions/adventure-actions'

export default function useAvailableDates(activityId, callback) {
  const dispatch = useDispatch()
  const [availabilities, setAvailabilites] = useState([])
  const [dates, setDates] = useState([])
  useEffect(() => {
    API(
      `/api/adventure/v1/${activityId}/detail/availabilities/`,
      false,
      false,
      true,
    )
      .get()
      .then((items) => {
        if(items.availabilities) {
          const dates = items.availabilities.map((availability) => {
            if(availability.capacity) {
              return availability.date
            }
          })
          setAvailabilites(items.availabilities)
          setDates(dates)
          dispatch(setAdventureAvailability(items.availabilities))

          if(callback) {
            callback(dates)
          }
        }
      })
  }, [])

  return { dates, availabilities }
}
